// React and related imports
import React from 'react';
import { useAppSelector } from '../../redux/hooks/useAppSelector';
import { selectIsDarkMode } from '../../redux/selectors/displaySettingsSelectors';

interface CreateButtonProps {
  onClick: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
  label: string;
}

export const CreateNewContentButton: React.FC<CreateButtonProps> = ({
  onClick,
  label,
}) => {
  const isDarkMode = useAppSelector(selectIsDarkMode);
  const buttonClassName = `btn ${isDarkMode ? 'btn-dark' : 'btn-light'}`;

  return (
    <div
      className={`${buttonClassName} icon-primary me-2 rounded-lg px-2 py-2 text-center text-sm font-medium`}
      onClick={onClick}
      role="button"
      tabIndex={0} // Ensure it's keyboard-accessible
    >
      {label}
    </div>
  );
};
